// FeedbackModal.js
import React, { useRef, useEffect, useState } from "react";

const FeedbackModal = ({ expertId, onClose, onSubmit }) => {
  const modalRef = useRef(null);
  const [liked, setLiked] = useState("yes");
  const [whatWentWrong, setWhatWentWrong] = useState("");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleOptionChange = (event) => {
    const optionValue = event.target.value;
    if (event.target.checked) {
      setSelectedOptions((prevSelectedOptions) => [
        ...prevSelectedOptions,
        optionValue,
      ]);
    } else {
      setSelectedOptions((prevSelectedOptions) =>
        prevSelectedOptions.filter((option) => option !== optionValue)
      );
    }
  };

  const handleLikedChange = (event) => {
    setLiked(event.target.value);
  };

  const handleWhatWentWrongChange = (event) => {
    setWhatWentWrong(event.target.value);
  };

  const handleSubmit = () => {
    const feedbackData = {
      expertId: expertId,
      liked,
      whatWentWrong,
    };
    const token = localStorage.getItem("USER_AUTH_TOKEN");
    fetch(`${baseUrl}/api/expert/feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(feedbackData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Feedback submitted successfully", data);
      })
      .catch((error) => {
        console.error("Error submitting feedback:", error);
      });
    onClose();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div
        ref={modalRef}
        className="bg-white mx-5 shadow-lg rounded-lg lg:w-1/3 p-6"
      >
        <h2 className="text-2xl font-bold mb-4">
          Your feedback is important.
        </h2>

        <div className=" mb-4">
          <p className="text-lg">1. Did you like it?</p>
          <div>
            <label className="text-base mr-4">
              <input
                type="radio"
                value="yes"
                checked={liked === "yes"}
                onChange={handleLikedChange}
              />
              <span className="ml-2">Yes</span>
            </label>
            <label className="text-base">
              <input
                type="radio"
                value="no"
                checked={liked === "no"}
                onChange={handleLikedChange}
              />
              <span className="ml-2">No</span>
            </label>
          </div>
        </div>
        {liked === "no" && (
          <div className="text-lg">
            <p>2. What went wrong?</p>
            {/* Options for users to select */}
            <label className="text-base" style={{ marginBottom: "8px" }}>
              <input
                type="checkbox"
                value="Option 1"
                checked={selectedOptions.includes("Option 1")}
                onChange={handleOptionChange}
              />
              &nbsp;1. Technical error disrupted the session.
            </label>
            <br />
            <label className="text-base" style={{ marginBottom: "8px" }}>
              <input
                type="checkbox"
                value="Option 2"
                checked={selectedOptions.includes("Option 2")}
                onChange={handleOptionChange}
              />
              &nbsp;2. I did not ge the solution for my problem.
            </label>
            <br />
            <label className="text-base" style={{ marginBottom: "8px" }}>
              <input
                type="checkbox"
                value="Option 3"
                checked={selectedOptions.includes("Option 3")}
                onChange={handleOptionChange}
              />
              &nbsp;3. The teacher was not available on scheduled time.
            </label>
            <br />
            <label className="text-base" style={{ marginBottom: "8px" }}>
              <input
                type="checkbox"
                value="Option 4"
                checked={selectedOptions.includes("Option 4")}
                onChange={handleOptionChange}
              />
              &nbsp;4. The teacher had not sufficient knowledge about my
              problem/topic
            </label>

            <p className="mt-4"> Other</p>
            <textarea
              className="w-full p-2 border rounded-md resize-none mb-4"
              placeholder="Please explain..."
              rows="2"
              value={whatWentWrong}
              onChange={handleWhatWentWrongChange}
            ></textarea>
          </div>
        )}

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md mr-2"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
